import React, { useRef } from "react"
import * as FaIcons from 'react-icons/fa';
import { Form, Button, Alert, Container, Spinner } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { useNavigate } from "react-router-dom"
import "../css/login.css"

//firebase
import { useState, useEffect } from "react";
import 'firebase/compat/firestore';

export default function Login() {
    const emailRef = useRef()
    const passwordRef = useRef()
    const [error, setError] = useState("")
    const { currentUser, logout, login, checkUsertype } = useAuth()
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    async function handleSubmit(e) {
        e.preventDefault()

        try {
            setError("")
            setLoading(true)

            await login(emailRef.current.value, passwordRef.current.value)

            navigate("/");

        } catch (error) {
            setError("Failed to log in")
            console.log(error);
        }

        setLoading(false)
    }

    return (
        <Container id="container" className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }} >
            <div className="w-100" id="card-container">
                <div id="cstm-shape">
                    {/* <svg className="cstm-shape" width="400" height="140" viewBox="0 0 400 140">
                        <polygon points="0,0 80,100 300,100 330,140 0,140" fill="blue" />
                        <polygon points="53,50 85,90 305,90 343,140 400,140 400,50" fill="green" />
                    </svg> */}
                    <h2 id="titlePage" className="text-center"> <FaIcons.FaMedium /> MentorWayz </h2>
                    <h5 id="titlePage2" className="text-center"> <span className="cntr-brdr"> Admin Login </span> </h5>
                </div>

                <div id="card-content">

                    { error && <Alert variant="danger"> {error} </Alert>}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group id="email">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" ref={emailRef} required />
                        </Form.Group>
                        <br />
                        <Form.Group id="password">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" ref={passwordRef} required />
                        </Form.Group>
                        <br />
                        <Button disabled={loading} id="login-btn" type="submit">
                            Sign In
                        </Button>
                    </Form>
                </div>
            </div>
        </Container>
    )
}